import React from "react"
import { usePathwrightContext } from "./PathwrightContext"

export const ThemeContext = React.createContext()

const ThemeContextProvider = ({ children }) => {
  const context = usePathwrightContext()
  return (
    <ThemeContext.Provider value={context.school.theme}>
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeContextProvider
